/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type SharedByFilterConfigKind = (typeof SharedByFilterConfigKind)[keyof typeof SharedByFilterConfigKind];

export const SharedByFilterConfigKind = {
  shared_by: 'shared_by',
} as const;
